import { ContextMenuPosition, Frame, Video } from "./types";
import { makeAutoObservable } from "mobx";

export class VideoStore {
    videos: Video[] = [];
    selectedVideo: Video | null = null;
    isModalOpen = false;
    currentTime = 0;
    isPlaying = false;
    duration = 0;
    frames: Frame[] = [];
    activeFrameIndex = 0;
    contextMenu: ContextMenuPosition | null = null;
    isHovering = false;

    constructor() {
        makeAutoObservable(this);
    }

    loadVideos(videos: Video[]) {
        this.videos = videos;
    }

    openVideo(video: Video) {
        this.selectedVideo = video;
        this.isModalOpen = true;
        this.currentTime = 0;
        this.isPlaying = true; // Auto-play on open
        this.frames = [];
        this.activeFrameIndex = 0;
    }

    closeModal() {
        this.isModalOpen = false;
        this.selectedVideo = null;
        this.isPlaying = false;
        this.contextMenu = null;
        this.isHovering = false;
    }

    setHovering(hovering: boolean) {
        this.isHovering = hovering;
    }

    setPlaying(playing: boolean) {
        this.isPlaying = playing;
    }

    setCurrentTime(time: number) {
        this.currentTime = time;
        this.updateActiveFrame();
    }

    setDuration(duration: number) {
        this.duration = duration;
    }

    setFrames(frames: Frame[]) {
        this.frames = frames;
    }

    updateActiveFrame() {
        if (this.frames.length === 0) return;
        const index = this.frames.findIndex((f, i) => {
            const nextFrame: Frame = this.frames[i + 1];
            return nextFrame ? this.currentTime < nextFrame.timestamp : true;
        });
        this.activeFrameIndex = Math.max(0, index);
    }

    seekToFrame(index: number) {
        if (index >= 0 && index < this.frames.length) {
            this.currentTime = this.frames[index].timestamp;
            this.activeFrameIndex = index;
        }
    }

    seekBySeconds(seconds: number) {
        const newTime = Math.max(
            0,
            Math.min(this.duration, this.currentTime + seconds),
        );
        this.currentTime = newTime;
    }

    showContextMenu(x: number, y: number) {
        this.contextMenu = { x, y };
    }

    hideContextMenu() {
        this.contextMenu = null;
    }
}
